/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import * as Yup from "yup";
import clsx from "clsx";
import { Link, Outlet } from "react-router-dom";
import { useFormik } from "formik";
// import { getUserByToken, login } from '../core/_requests'
import { toAbsoluteUrl } from "../../../_metronic/helpers";
// import { useAuth } from '../core/Auth'
//redux
// import { useDispatch } from 'react-redux';
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  loginUser,
  setUserError,
  setUserLoading,
} from "../../redux/slices/user/userSlice";
import axios from "axios";
import { cls } from "react-image-crop";
import { BASE_URL_API_PANEL } from "../../CONSTANTS";

const API_URL = BASE_URL_API_PANEL;

const loginSchema = Yup.object().shape({
  // email: Yup.string()
  //     .min(3, 'حداقل 3 کاراکتر')
  //     .max(50, 'حداکثر 50 کاراکتر')
  //     .required('نام کاربری الزامی است')
  //     .matches(/^(?=.*[a-zA-Z])(?=.*[\d])(?=.*[^\w\s]).+$/, 'حروف انگلیسی - حداقل یک نشانک - حداقل یک عدد'),
  // password: Yup.string()
  //     .min(3, 'حداقل 3 کاراکتر')
  //     .max(50, 'حداکثر 50 کاراکتر')
  //     .required('رمز عبور اشتباه است'),
});

const initialValues = {
  email: "",
  password: "",
};

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

function Login() {
  // const [loading, setLoading] = useState(false)
  // const { saveAuth, setCurrentUser } = useAuth()
  // const [userLoged, setUserLoged] = useState(false);

  const dispatch = useAppDispatch();
  const auth = useAppSelector((state) => state.auth);

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      // setLoading(true)

      const items = {
        username: values.email,
        password: values.password,
      };

      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };

      try {
        dispatch(setUserLoading());
        // const {data: auth} = await login(values.email, values.password)
        // saveAuth(auth)
        // console.log(saveAuth(auth));
        // const {data: user} = await getUserByToken(auth.api_token)
        // setCurrentUser(user)
        axios
          .post(`${API_URL}operator/login`, items, { headers: headers })
          .then((response) => {
            const userData = response.data;
            dispatch(loginUser(userData));
            // setUserLoged(true)
          })
          .catch((e) => {
            console.error(e);
            // saveAuth(undefined)
            // setStatus('The login details are incorrect')
            // setSubmitting(false)
            // setLoading(false)
            dispatch(setUserError());
          });
      } catch (error) {
        console.error(error);
        // saveAuth(undefined)
        // setStatus('The login details are incorrect')
        // setSubmitting(false)
        // setLoading(false)
        dispatch(setUserError());
      }
    },
  });

  return (
    <form
      className="form w-100"
      onSubmit={formik.handleSubmit}
      noValidate
      id="kt_login_signin_form"
    >
      {/* begin::Heading */}
      <div className="text-center mb-11">
        {/* <img src={toAbsoluteUrl('/media/auth/trasafar/logo.png')} alt='' /> */}
        <div className="w-100 d-flex justify-content-center ">
          <div
            className="mb-5 rounded-3 "
            style={{
              width: "200px",
              height: "200px",
            }}
          >
            <img
              src={toAbsoluteUrl("/media/auth/tractorLogo.svg")}
              alt=""
              style={{
                width: "200px",
                height: "200px",
              }}
            />
            <h1
              style={{
                marginTop: "45px",
                color: "#a90607",
              }}
            >
              {" "}
              تراکتور{" "}
            </h1>
          </div>
        </div>
        <h1 className="text-dark fw-bolder mb-6"> ورود به پنل بلیت فروشی </h1>
      </div>
      {/* begin::Heading */}

      {/* begin::Form group */}
      <div className="fv-row mb-8">
        <label className="form-label fs-6 fw-bolder text-dark">
          {" "}
          نام کاربری
        </label>
        <input
          {...formik.getFieldProps("email")}
          className={clsx(
            "form-control bg-transparent",
            { "is-invalid": formik.touched.email && formik.errors.email },
            {
              "is-valid": formik.touched.email && !formik.errors.email,
            }
          )}
          type="text"
          name="email"
          autoComplete="off"
        />
        {formik.touched.email && formik.errors.email && (
          <div className="fv-plugins-message-container">
            <span role="alert">{formik.errors.email}</span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className="fv-row mb-3">
        <label className="form-label fw-bolder text-dark fs-6 mb-0">
          رمز عبور
        </label>
        <input
          type="password"
          autoComplete="off"
          {...formik.getFieldProps("password")}
          className={clsx(
            "form-control bg-transparent",
            {
              "is-invalid": formik.touched.password && formik.errors.password,
            },
            {
              "is-valid": formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <span role="alert">{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}
      {/*TODO: proper error handling*/}

      {auth.status === "error" && <div className={"text-danger"}>خطا </div>}
      {/* begin::Action */}
      <div className="d-grid mb-10 mt-7">
        <button
          type="submit"
          id="kt_sign_in_submit"
          className="btn text-white"
          style={{ background: "#a90607" }}
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {auth.status !== "loading" ? (
            <span className="indicator-label">تایید</span>
          ) : (
            <span className="indicator-progress" style={{ display: "block" }}>
              درحال ورود...
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}
    </form>
  );
}

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById("root");
    if (root) {
      root.style.height = "100%";
    }
    return () => {
      if (root) {
        root.style.height = "auto";
      }
    };
  }, []);

  return (
    <div className="d-flex flex-column flex-lg-row flex-column-fluid h-100">
      {/* begin::Body */}
      <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
        {/* begin::Form */}
        <div className="d-flex flex-center flex-column flex-lg-row-fluid">
          {/* begin::Wrapper */}
          <div className="w-lg-500px p-10">
            <Login />
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Form */}

        {/* begin::Footer */}
        <div className="d-flex flex-center flex-wrap px-5">
          {/* begin::Links */}
          {/* <div className='d-flex fw-semibold text-primary fs-base'>
                        <a href='#' className='px-5' target='_blank'>
                            Terms
                        </a>

                        <a href='#' className='px-5' target='_blank'>
                            Plans
                        </a>

                        <a href='#' className='px-5' target='_blank'>
                            Contact Us
                        </a>
                    </div> */}
          {/* end::Links */}
        </div>
        {/* end::Footer */}
      </div>
      {/* end::Body */}

            {/* begin::Aside */}
            <div
                className='d-none d-lg-flex  flex-lg-row-fluid position-relative w-lg-50 bgi-size-contain bgi-repea bgi-position-center order-1 order-lg-2 '
                style={{backgroundImage: `url(${toAbsoluteUrl('/media/misc/loginImage.png')})`,
                    backgroundRepeat:"no-repeat",  
                    backgroundSize: "cover",
                    backgroundPosition: "left",
                    height: '100vh',
                    width: '100%'}}
            >
                <div className=' h-100 position-absolute d-flex align-items-center justify-content-center' style={{width:"100%",background:"rgba(169, 6, 7, 0.52) "}}>
                        <p className='text-white display-6'>باشگاه فرهنگی، ورزشی و اقتصادی <br/><span className=' display-1'>تراکتور</span></p>
                </div>
                {/* begin::Content */}
                <div className='d-flex flex-column flex-center py-15 px-5 px-md-15 w-100'>
                    {/* begin::Logo */}
                    {/* <Link to='/' className='mb-12'>
                        <img alt='Logo' src={toAbsoluteUrl('/media/logos/custom-1.png')} className='h-75px'/>
                    </Link> */}
          {/* end::Logo */}

          {/* begin::Image */}
          {/* <img
                        className='mx-auto w-275px w-md-50 w-xl-500px mb-10 mb-lg-20'
                        src={toAbsoluteUrl('/media/misc/auth-screens.png')}
                        alt=''
                    /> */}
          {/* end::Image */}

          {/* begin::Title */}
          {/* <h1 className='text-white fs-2qx fw-bolder text-center mb-7'>
                        Fast, Efficient and Productive
                    </h1> */}
          {/* end::Title */}

          {/* begin::Text */}
          {/* <div className='text-white fs-base text-center'>
                        In this kind of post,{' '}
                        <a href='#' className='opacity-75-hover text-warning fw-bold me-1'>
                            the blogger
                        </a>
                        introduces a person they’ve interviewed <br/> and provides some background information
                        about
                        <a href='#' className='opacity-75-hover text-warning fw-bold me-1'>
                            the interviewee
                        </a>
                        and their <br/> work following this is a transcript of the interview.
                    </div> */}
          {/* end::Text */}
        </div>
        {/* end::Content */}
      </div>
      {/* end::Aside */}
    </div>
  );
};

export default AuthLayout;
